import React from "react";
import { Stack } from "@mui/material";
import { observer } from "mobx-react";
import { MiscellaneousMessagesSettings } from "../MiscellaneousMessagesSettings";
import { DefaultButtonTextSettings } from "../DefaultButtonTextSettings";
import { WelcomePageCustomisation } from "../WelcomePageCustomisation";
import { ThankYouPageCustomisation } from "../ThankYouPageCustomisation";
import { ResetSurveySettingsSection } from "../ResetSurveySettingsSection";
import { useTranslation } from "react-i18next";
import {
  useFoundationColorTokens,
  useSpacing,
  useTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import { useRouteNavigator } from "../../../../../routes/RoutesHelper";
import { useSurveyStore } from "../../../../store/Hooks";
import { SurveySettingsTabContentHeader } from "../SurveySettingsTabContentHeader";
import { SurveySettingsTab } from "../SurveySettingsPaneTab";

export const SurveySettingsSurveyUITab: React.FC = observer(() => {
  const { t } = useTranslation();
  const spacing = useSpacing();
  const typography = useTypography();
  const tokens = useFoundationColorTokens();
  const navigateTo = useRouteNavigator();
  const surveyStore = useSurveyStore();

  const updatedBackOfficeSurveySettings =
    surveyStore.backOfficeSurveySettingsStore.updatedBackOfficeSurveySettings;
  const initialBackOfficeSurveySettings =
    surveyStore.backOfficeSurveySettingsStore.initialBackOfficeSurveySettings;

  if (!updatedBackOfficeSurveySettings || !initialBackOfficeSurveySettings) {
    return;
  }

  const updatedBackOfficeSurveySettingsUIStore =
    updatedBackOfficeSurveySettings.backOfficeSurveySettingsUIStore;
  const surveySettings = updatedBackOfficeSurveySettings.surveySettings;

  return (
    <Stack id={SurveySettingsTab.SurveyUI}>
      <SurveySettingsTabContentHeader
        title={t("surveys.settings.surveyUISectionLabel", "Survey UI")}
      />
      <MiscellaneousMessagesSettings
        miscellaneousSettingsTexts={
          surveySettings.miscellaneousSurveySettingsText
        }
        updatedBackOfficeSurveySettings={updatedBackOfficeSurveySettings}
        t={t}
        spacing={spacing}
        typography={typography}
        tokens={tokens}
      />
      <DefaultButtonTextSettings
        updatedBackOfficeSurveySettings={updatedBackOfficeSurveySettings}
        clearError={updatedBackOfficeSurveySettingsUIStore.clearError}
        t={t}
        spacing={spacing}
        typography={typography}
        tokens={tokens}
      />
      <WelcomePageCustomisation
        isWelcomePageShown={updatedBackOfficeSurveySettings.isWelcomePageShown}
        setIsWelcomePageShown={
          updatedBackOfficeSurveySettings.setIsWelcomePageShown
        }
        welcomePageText={initialBackOfficeSurveySettings.welcomePageText}
        setWelcomePageText={updatedBackOfficeSurveySettings.setWelcomePageText}
        t={t}
        spacing={spacing}
        typography={typography}
        tokens={tokens}
        isWelcomePageTextErrored={updatedBackOfficeSurveySettingsUIStore.isWelcomePageTextErrored(
          updatedBackOfficeSurveySettings.welcomePageText,
        )}
        rteFileService={
          updatedBackOfficeSurveySettings.welcomePageTextRTEFileService
        }
        updatedWelcomePageText={updatedBackOfficeSurveySettings.welcomePageText}
      />
      <ThankYouPageCustomisation
        thankYouPageText={initialBackOfficeSurveySettings.thankYouPageText}
        setThankYouPageText={
          updatedBackOfficeSurveySettings.setThankYouPageText
        }
        t={t}
        spacing={spacing}
        typography={typography}
        tokens={tokens}
        isThankYouPageTextErrored={updatedBackOfficeSurveySettingsUIStore.isThankYouPageTextErrored(
          updatedBackOfficeSurveySettings.thankYouPageText,
        )}
        isFIThankYouPageLogoShown={
          updatedBackOfficeSurveySettings.surveySettings
            .isFIThankYouPageLogoShown
        }
        setIsFIThankYouPageLogoShown={
          updatedBackOfficeSurveySettings.surveySettings
            .setIsFIThankYouPageLogoShown
        }
        rteFileService={
          updatedBackOfficeSurveySettings.thankYouPageTextRTEFileService
        }
        updatedThankYouPageText={
          updatedBackOfficeSurveySettings.thankYouPageText
        }
      />
      <ResetSurveySettingsSection
        navigateTo={navigateTo}
        t={t}
        spacing={spacing}
        typography={typography}
        tokens={tokens}
        backOfficeSurveySettingsStore={
          surveyStore.backOfficeSurveySettingsStore
        }
      />
    </Stack>
  );
});
